import { isNil } from 'ramda';

import { IFeatureItem } from 'shared/types/offerData';

export const getOfferFeature = (name: string, text: string, hasValue: boolean | null): IFeatureItem | null => {
  if (isNil(hasValue)) {
    return null;
  }

  // Текст может быть пустой строкой, поэтому по-умолчанию используем "Есть"
  const value = hasValue ? text || 'Есть' : 'Нет';

  return { name, value };
};
